/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace */

import {
  Component,
  OnInit
}                                from '@angular/core';

import { Logger                } from '@/util/logger';

@Component({
  standalone: false,
  templateUrl: 'privacy.component.html'
})

/**
 *
 * @class PrivacyComponent
 *
 * @brief privacy policy/statement page
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      October 2022
 *
 */
export class PrivacyComponent implements OnInit {

  /** standard constructor */
  constructor(
  ) {

  }

  /** on page setup */
  ngOnInit() {

    Logger.debug('[PrivacyComponent] init...');



  }

}

